/**
 * @constant LinkedAccountsNotEligibleGenerations
 * @type {Array<string>}
 * @description An array of generations specific to the LinkedAccounts.
 **/
export const LinkedAccountsNotEligibleGenerations: Array<string> = ['17cyplus', '17cy'];
/* @constant SubHistoryEligibleGenerations
* @type {Array<string>}
* @description An array of generations specific to the subscription History.
**/
export const SubHistoryEligibleGenerations: Array<string> = ['17cyplus', '21mm', '24mm', 'gr86'];
/**
 * @constant ProvisionEligibleGenerations
 * @type {Array<string>}
 * @description An array of generations specific to the Provisioning History.
 **/
export const ProvisionEligibleGenerations: Array<string> = ['17cyplus', '21mm', '24mm'];
/**
 * @constant SortCapabilitiesEligibleGenerations
 * @type {Array<string>}
 * @description An array of generations specific to the sort capabilities.
 **/
export const SortCapabilitiesEligibleGenerations: Array<string> = ['17cyplus', '21mm', '24mm'];
/**
 * @constant DestCapabilityEligibleGenerations
 * @type {Array<string>}
 * @description An array of generations specific to the destination capability.
 **/
export const DestCapabilityEligibleGenerations: Array<string> = ['21mm', '24mm'];

/**
 * @constant SortCapabilitiesEligibleGenerations
 * @type {Array<string>}
 * @description An array of generations specific to the sort capabilities.
 **/
export const SettableFlagsEligibleGenerations: Array<string> = ['17cyplus', '21mm', '24mm'];

/**
 * @constant ProvisionEligibleGenerations
 * @type {Array<string>}
 * @description An array of generations specific to the Provisioning History.
 **/
export const DcmEligibleGenerations: Array<string> = ['21MM', '24MM', '17CYPLUS'];

/**
 * @constant UserProfileEligibleGenerations
 * @type {Array<string>}
 * @description An array of generations specific to the user profile.
 **/
export const UserProfileEligibleGenerations: Array<string> = ['21MM', '24MM'];

/**
 * @constant LinkedAccountsEligibleGenerations
 * @type {Array<string>}
 * @description An array of generations specific to the LinkedAccounts.
 **/

export const LinkedAccountsEligibleGenerations: Array<string> = ['21mm', '24mm'];

/** @constant SpotifyEligibleGenerations
* @type {Array<string>}
* @description An array of generations specific to the LinkedAccounts spotify feature.
**/
export const SpotifyEligibleGenerations: Array<string> = ['24mm'];

/** @constant AmazonMusicEligibleGenerations
* @type {Array<string>}
* @description An array of generations specific to the LinkedAccounts Amazon Music feature.
**/
export const AmazonMusicEligibleGenerations : Array<string> = ['21mm'];

/**
 * @constant unlinkEligibleGenerations
 * @type {Array<string>}
 * @description An array of generations specific to the unlink vehicles.
 **/

export const unlinkEligibleGenerations: Array<string> = ['21mm', '24mm'];
/**
 * @constant digitalKeyEligibleGenerations
 * @type {Array<string>}
 * @description An array of generations specific to the display digitalKey.
 **/

export const digitalKeyEligibleGenerations: Array<string> = ['21mm', '24mm'];
/**
 * @constant adminPortalApiTypes
 * @type {Array<string>}
 * @description An array of api types specific to new gateway.
 **/

export const adminPortalApiTypes: Array<string> = ['tss-request',
    'outage-banner',
    'authorize-cms',
    'cms-request-group-info',
    'cms-request-group-id',
    'cms-service-desk-id',
    'cms-organization',
    'cms-validate-user',
    'cms-attach-file',
    'cms-request-group-fields',
    'plug_and_charge',
    'cms-create-ticket', 'userprofile', 'linked-accounts', 'vehicle-history'];

/**
 * @constant linkedAccountsNotEligibleRegions
 * @type {Array<string>}
 * @description An array of regions not specific to the LinkedAccounts.
 **/

export const linkedAccountsNotEligibleRegions: Array<string> = ['ca', 'mx'];

/**
 * @constant ProvisioningCardEligibleRegions
 * @type {Array<string>}
 * @description An array of regions specific to the Provisioning.
 **/

export const provisioningCardEligibleGenerations: Array<string> = ['17cyplus', '21mm', '24mm'];